<script lang="ts">
  import { push } from 'svelte-spa-router';
  import Icon from '../components/Icon.svelte';
  import { login, ApiError } from '../lib/api';

  let email = $state('');
  let password = $state('');
  let submitting = $state(false);
  let errorMsg = $state<string | null>(null);

  async function onSubmit(e: SubmitEvent) {
    e.preventDefault();
    submitting = true;
    errorMsg = null;
    try {
      await login(email, password);
      push('/');
    } catch (err) {
      if (err instanceof ApiError) {
        if (err.code === 'auth.invalid_credentials') errorMsg = 'Невірний email або пароль';
        else if (err.code === 'auth.locked') errorMsg = 'Акаунт тимчасово заблоковано через невдалі спроби';
        else if (err.code === 'auth.account_disabled') errorMsg = 'Акаунт деактивовано';
        else if (err.code === 'rate_limit.exceeded') errorMsg = 'Забагато спроб. Зачекайте хвилину.';
        else errorMsg = err.message;
      } else {
        errorMsg = String(err);
      }
    } finally {
      submitting = false;
    }
  }
</script>

<div class="auth-bg min-h-screen flex items-center justify-center p-6">
  <form
    onsubmit={onSubmit}
    class="auth-card w-full max-w-md rounded-2xl border border-white/10 bg-white/5 p-9 backdrop-blur-xl shadow-2xl"
  >
    <div class="flex items-center gap-3 mb-7">
      <div class="auth-logo-mark">F</div>
      <div>
        <div class="text-sm font-bold text-white tracking-wide">FocusOnYou</div>
        <div class="text-[10px] uppercase tracking-[2px] text-white/50 mt-0.5">Marketing Analytics</div>
      </div>
    </div>

    <h1 class="text-xl font-semibold text-white mb-1.5">Вхід в кабінет</h1>
    <p class="text-xs text-white/60 mb-6 leading-relaxed">
      Введіть свої облікові дані. Якщо ви ще не маєте доступу — попросіть адміністратора надіслати запрошення.
    </p>

    <label for="login-email" class="block text-xs text-white/65 font-medium mb-1.5">Email</label>
    <input
      id="login-email"
      type="email"
      bind:value={email}
      required
      autocomplete="email"
      placeholder="ім'я@focusonyou.com.ua"
      class="auth-field block w-full rounded-lg bg-white/[0.07] border border-white/20 px-3.5 py-2.5 text-sm text-white mb-3.5 focus:border-[var(--color-pu-2)] focus:outline-none"
    />

    <label for="login-password" class="block text-xs text-white/65 font-medium mb-1.5">Пароль</label>
    <input
      id="login-password"
      type="password"
      bind:value={password}
      required
      autocomplete="current-password"
      placeholder="••••••••••"
      class="auth-field block w-full rounded-lg bg-white/[0.07] border border-white/20 px-3.5 py-2.5 text-sm text-white mb-4 focus:border-[var(--color-pu-2)] focus:outline-none"
    />

    {#if errorMsg}
      <div class="mb-3 rounded-md border border-red-500/40 bg-red-500/10 px-3 py-2 text-xs text-red-200">
        {errorMsg}
      </div>
    {/if}

    <button
      type="submit"
      disabled={submitting}
      class="w-full rounded-lg py-3 text-sm font-semibold text-white shadow-lg disabled:opacity-60"
      style="background: linear-gradient(135deg, var(--color-pu), var(--color-pu-2));"
    >
      {submitting ? 'Входимо…' : 'Увійти →'}
    </button>

    <div
      class="mt-5 rounded-lg border border-sky-400/30 bg-sky-400/10 px-3 py-2.5 text-xs text-sky-200 flex gap-2 leading-relaxed"
    >
      <span class="inline-flex shrink-0 mt-0.5"><Icon name="lock" size={14} /></span>
      <span>
        Реєстрація через цю сторінку <strong>не можлива</strong>. Доступ видається тільки адміністратором через invitation-лінк.
      </span>
    </div>
  </form>
</div>

<style>
  .auth-bg {
    background: linear-gradient(165deg, var(--color-dark) 0%, var(--color-dark-3) 60%, #6b3a9e 100%);
  }
  .auth-logo-mark {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: linear-gradient(135deg, var(--color-pu-2), var(--color-pu-mid));
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 800;
    font-size: 16px;
  }
</style>
